import axios from '../config/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api` || 'http://localhost:7000/api';

const studyDesignSelectionService = {
  // Load selected document IDs for a project
  getSelection: async (projectId) => {
    try {
      const response = await axios.get(`${API_URL}/study-design-selection/${projectId}`);
      return response.data?.selectedDocs || [];
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Save selected document IDs for a project (replaces previous selection)
  saveSelection: async (projectId, selectedDocs) => {
    try {
      const response = await axios.put(`${API_URL}/study-design-selection/${projectId}`, {
        selectedDocs: Array.isArray(selectedDocs) ? selectedDocs : [...selectedDocs],
      });
      return response.data?.selectedDocs || [];
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default studyDesignSelectionService;
